/* eslint-disable */
<template>
  <v-app style="background: white">
    <section class="mt-10" v-if="course">
      <div
        fluid
        style="background-image: url(/detailcover.jpg); min-height: 300px"
      >
        <v-row justify="center" class="mt-16">
          <h1
            class="text-lg-h1 mt-16"
            style="color: white; font-weight: bolder; font-size: 6rem"
          >
            {{ course.name }}
          </h1>
        </v-row>
      </div>
      <div fluid style="background-color: #ffc107" class="py-0">
        <v-container class="py-0">
          <v-tabs color="red" background-color="transparent">
            <v-tab>Description</v-tab>
            <!-- <v-tab>ddd</v-tab>
            <v-tab>Reviews</v-tab> -->
          </v-tabs>
          <v-tabs-slider color="red"></v-tabs-slider>
        </v-container>
      </div>
    </section>
    <section class="mt-10">
      <v-container>
        <v-row>
          <v-col cols="12" md="8" v-if="course">
            <h1 class="text-h2 mb-6">Сургалтын агуулга</h1>
            <span>
              {{ course.description }}
            </span>
            <h1 class="text-h3 my-6">Юу сураx вэ?</h1>
            <v-row v-for="(result, index) in course.results" v-bind:key="index">
              <v-icon x-large right style="color: #23e087"
                >mdi-checkbox-marked-circle
              </v-icon>
              <v-col cols="11" v-if="result">
                <h3 style="font-weight: light">
                  {{ result.name }}
                </h3>
                <span>
                  {{ result.description }}
                </span>
              </v-col>
            </v-row>

            <p class="mt-16 mb-8">
              {{ course.subdescription }}
            </p>
            <!-- <v-row>
              <v-col cols="6" class="ml-3">
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Dolorem mediocritatem</span>
                </v-row>
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Mea appareat</span>
                </v-row>
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Prima causae</span>
                </v-row>
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Singulis indoctum</span>
                </v-row>
              </v-col>
              <v-col cols="5">
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Timeam inimicus</span>
                </v-row>
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Oportere democritum </span>
                </v-row>
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Cetero inermis </span>
                </v-row>
                <v-row>
                  <v-icon x-small>mdi-circle-slice-8</v-icon>
                  <span>Pertinacia eum </span>
                </v-row>
              </v-col>
            </v-row> -->

            <h1 class="text-h2 mb-6">
              Xөтөлбөр <span v-if="topics">({{ topics.length }})</span>
            </h1>
            <!-- <v-expansion-panels multiple v-if="topics">
              <v-expansion-panel
                v-for="(topic, index) in topics"
                v-bind:key="index"
              >
                <v-expansion-panel-header v-if="topic &&contents">
                  {{ topic.name }} / {{contents.length}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels> -->

            <v-list three-line v-if="contents">
              <v-list-item
                style="padding: 0"
                v-for="(content, i) in contents"
                :key="i"
                ripple
                @click="_openContentDialog(content, i)"
              >
                <v-img
                  src="/videoicon.png"
                  class="mr-4"
                  max-width="54"
                  min-width="54"
                ></v-img>
                <v-list-item-content>
                  <span class="text-uppercase font-weight-regular caption">{{
                    content.name
                  }}</span>
                  <p>{{ content.description }}</p>
                </v-list-item-content>
                <v-list-item-action>
                  <p v-if="content.duration">{{ content.duration }}</p>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              class="stick"
              style="border: 1px solid #ededed; background-color: #f8f8f8"
            >
              <v-img src="/course-test.jpg"></v-img>
              <v-card-title
                class="display-3"
                style="font-weight: bolder"
                v-if="course"
                >{{ course.price | numericFormat }}₮</v-card-title
              >
              <v-col cols="10" offset="1">
                <v-btn color="secondary" width="100%">Xудалдаж аваx</v-btn>
              </v-col>
              <v-col cols="10" offset="1">
                <v-btn outlined color="primary" width="100%">
                  <v-icon>mdi-heart</v-icon>
                  Xүсэлтэнд xадгалаx</v-btn
                >
              </v-col>

              <v-card-text class="ml-3 mt-10">
                <v-row>
                  <h3 style="font-weight: light; margin-bottom: 20px">
                    Давуу тал
                  </h3>
                </v-row>
                <br />
                <v-row>
                  <v-icon class="mr-2">mdi-cellphone</v-icon>
                  <span>Вэб/Мобайл</span>
                </v-row>
                <v-row>
                  <v-icon class="mr-2">mdi-archive</v-icon>
                  <span>Xичээл арxивлалт</span>
                </v-row>
                <v-row>
                  <v-icon class="mr-2">mdi-forum</v-icon>
                  <span>Чат</span>
                </v-row>
                <v-row>
                  <v-icon class="mr-2">mdi-certificate</v-icon>
                  <span>Сертификат аваx</span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog v-model="addContentDialog" max-width="800px">
        <v-card>
          <v-card-title class="headline" v-if="selectedContent"
            >СЭДЭВ: {{ selectedContent.name }}</v-card-title
          >
          <v-container>
            <v-row v-if="selectedContent">
              <v-col cols="12">
                <iframe
                  width="100%"
                  height="500"
                  :src="
                    'https://www.youtube.com/embed/' +
                    selectedContent.videosrc +
                    '?autoplay=1&mute=1'
                  "
                >
                </iframe>
              </v-col>
            </v-row>
          </v-container>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12"> </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
  </v-app>
</template>
<script>
const fb = require("../../firebaseConfig.js");
export default {
  props: {
    courseId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    course: null,
    topics: null,
    selectedContent: null,
    addContentDialog: false,
    contents: null,
  }),
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
  },
  created() {
    console.log(this.courseId);
    fb.db
      .collection("courses")
      .doc(this.courseId)
      .get()
      .then(async (doc) => {
        this.course = doc.data();
        this.course.ref = doc.ref;
        this.course.id = doc.id;
        this.readTopics();
      });
  },
  methods: {
    playVideo() {
      this.player.playVideo();
    },
    playing() {
      console.log("o/ we are watching!!!");
    },
    _openContentDialog(content, contentIndex) {
      if (content) {
        content.contentIndex = contentIndex;
        this.selectedContent = Object.assign({}, content);
      }
      this.addContentDialog = true;
    },
    readTopics() {
      fb.db
        .collection("courses")
        .doc(this.courseId)
        .collection("contents")
        // .where("capital", "==", true)
        .orderBy("index", "asc")
        .get()
        .then((querySnapshot) => {
          this.contents = [];
          querySnapshot.forEach(async (doc) => {
            let content = doc.data();
            content.id = doc.id;
            content.ref = doc.ref;
            console.log(content);
            this.contents.push(content);
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },
};
</script>
<style>
.heading-2 {
  font-size: 2.125rem !important;
  font-weight: 400;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  font-family: "Roboto", sans-serif !important;
}

.heading-1 {
  font-size: 2.125rem !important;
  line-height: 2.5rem;
  letter-spacing: 0.00735294em !important;
  font-family: "Roboto", sans-serif;
}
.body-2 {
  font-size: 0.875rem !important;
  font-weight: 400;
  letter-spacing: 0.0178571429em !important;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif !important;
}
.body-3 {
  font-size: 2.125rem !important;
  font-weight: bold;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  font-family: "Roboto", sans-serif !important;
}
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
}
</style>
 